import React from "react";
import type { ModeRendererProps } from "./types";

export function VasarelyWolfMode({ Copy }: ModeRendererProps) {
  return (
    <g>
      <rect width={794} height={1123} fill="#eef2ff" />
      <polygon points="180,620 397,280 614,620 520,700 274,700" fill="#7a7f86" />
      <g className="mode-copy" transform="translate(48,840)" fill="#111"><text x={0} y={0} fontSize={18}>{Copy?.title}</text></g>
    </g>
  );
}

export default VasarelyWolfMode;
